import { Component, OnInit } from '@angular/core';
import { BPProfilesService } from '../../bp-profiles.service';
import { BrowseListConfigService, IBrowseListConfig } from '../../../../shared/browselists/browselists-config.service';
import { IObject } from '../../../../../type_definitions/datatypes';
import { GridOptions } from 'ag-grid-community';
import { TranslationService } from '../../../../shared/translation/translation.service';

@Component({
  selector: 'bp-profiles-internal-config',
  template: `
    <report-wrapper
      [title]="('BPPROFILES.INTERNAL_CONFIG.TEXT' | translate)"
      [browselistConfig]="browselistConfig"
      [filters]="filters"
      [showActions]="true"
      [gridOptions]="gridOptions"
      storedReport="BP_INTERNAL_CONFIG"
    ></report-wrapper>
  `
})
export class BPProfilesInternalConfigComponent implements OnInit {
  public browselistConfig:IBrowseListConfig;
  public filters:IObject = {};
  public gridOptions:GridOptions = {};

  constructor(
    private bpProfilesService:BPProfilesService,
    private browseListConfigService:BrowseListConfigService,
    private translationService:TranslationService
  ) {
    /**/
  }

  public ngOnInit():void {
    this.browselistConfig = this.browseListConfigService.getConfig('EXTPREL');
    this.gridOptions = {
      sideBar: false, // remove right sidebar
      overlayNoRowsTemplate: `<div class="ag-overlay-no-rows-center"><h2>${this.translationService.instant('GA.GENERAL.NO_RESULTS_FOUND')}</h2><div>` // change text when no results found
    };

    // init filters
    this.filters = {
      Customer_name: this.bpProfilesService.activeProfile?.company?.id
    };
  }
}